// Modal as a separate component
import React, {useState, useEffect } from "react";
import { StyledModal, ModalOverlay } from "./partialStyles";

function Modal({ show, modalStyle, className = '', children, onClose, showCloseButton = false, closeOnOverlayClick = false, wide = false }) {

  useEffect(() => {
    if (show) {
      setIsShowing(true);
    } else {
      setIsShowing(false);
    }
  }, [show]);

  const [ isShowing, setIsShowing ] = useState(false);
  const shouldRenderChild = useDelayUnmount(isShowing, 500);
  
  let classes = className;
  if (modalStyle === "reachable") {
    classes += " reachable";
  } else if (modalStyle === "dropdown") {
    classes += " dropdown";
  }

  if (!isShowing) {
    classes += " closing";
  }
  if (wide) {
    classes += " wide";
  }

  function useDelayUnmount(isShowing, delayTime) {
    const [ shouldRender, setShouldRender ] = useState(false);

    useEffect(() => {
        let timeoutId;
        if (isShowing && !shouldRender) {
            setShouldRender(true);
        }
        else if(!isShowing && shouldRender) {
            timeoutId = setTimeout(
                () => setShouldRender(false), 
                delayTime
            );
        }
        return () => clearTimeout(timeoutId);
    }, [isShowing, delayTime, shouldRender]);
    return shouldRender;
  }

  // Add ref for modal content
  const modalContentRef = React.useRef(null);

  // Handle click outside modal content
  function handleOverlayClick(e) {
    if (!closeOnOverlayClick) return;
    if (modalContentRef.current && !modalContentRef.current.contains(e.target)) {
      if (onClose) onClose();
    }
  }

  // Handle Escape key to close
  useEffect(() => {
    if (!show) return;
    function handleKeyDown(e) {
      if (e.key === 'Escape' && onClose) onClose();
    }
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [show, onClose]);

  return (
    <>
      {shouldRenderChild && 
        <StyledModal className={classes} onMouseDown={handleOverlayClick}>
          <ModalOverlay />
          <section
            className="modal-content scrollable-modal-content"
            ref={modalContentRef}
            onMouseDown={e => e.stopPropagation()}
          >
            {/* X Close Button */}
            {showCloseButton && (
              <button
                className="modal-close-btn"
                aria-label="Close"
                onClick={onClose}
                style={{ position: 'absolute', top: 16, right: 16, background: 'none', border: 'none', fontSize: 28, cursor: 'pointer', zIndex: 2 }}
              >
                &times;
              </button>
            )}
            {children}
          </section>
        </StyledModal>
      }
    </>
  );
}

export default Modal;